import createModule from "../createModule"
import view from "./view"
import { get } from "lodash"
import { Creators } from "model/hookUpdater"
import { getRole } from "helpers/permissions/roles"
import { getDatasetTokens, getTokens, getTabs } from "./selectors"
import withUrlParams from "hocs/withUrlParams"

import "./styles.scss"

export default withUrlParams(createModule({
  view,
  externalProps: (state, props) => ({
    account: get(state, "global.selected.account"),
    datasetId: get(props, "params.datasetId"),
  }),
  required: ["account", "datasetId"],
  data: [{
    resource: "tokens",
    url: () => ({
      id: "tokens",
      query: `query {
          tokens {
            id
            name
          }
        }`,
    }),
  },
  {
    resource: "datasetEntitlements",
    url: ({ account, datasetId }) => `/api/${account}/reports/entitlements/dataset/${datasetId}`,
  }],
  mapStateToProps: (state, props) => ({
    role: getRole(state),
    userId: get(state, "user.id"),
    datasetTokens: getDatasetTokens(state),
    tokens: getTokens(state, props),
    tabs: getTabs(state, props),
  }),
  actions: {
    ...Creators,
  },
}))
